import { QueueType } from '../../multiskill/types';
import { DisplayMode } from '../../report/resourcing';
import { PLAN_COLORS } from '../../wizard/constants';
import { MULTISKILL_COLOR } from '../constants';
import { generateVariances } from '../selectors';
export function getScenarioCellColor(scenario) {
    var _a, _b;
    if ((scenario === null || scenario === void 0 ? void 0 : scenario.dataType) === QueueType.Multiskill) {
        return MULTISKILL_COLOR;
    }
    return (_b = PLAN_COLORS[(_a = scenario === null || scenario === void 0 ? void 0 : scenario.colorIndex) !== null && _a !== void 0 ? _a : -1]) === null || _b === void 0 ? void 0 : _b[1];
}
export function isGroupedMultiskillScenario(scenario, group, isMultiskillQueue) {
    if (isMultiskillQueue === void 0) { isMultiskillQueue = false; }
    return (scenario === null || scenario === void 0 ? void 0 : scenario.dataType) === QueueType.Multiskill && (group != null || isMultiskillQueue);
}
export function getGroupedMultiskillScenarioCellColor(scenario, group, isMultiskillQueue) {
    var _a, _b;
    if (isMultiskillQueue === void 0) { isMultiskillQueue = false; }
    return isGroupedMultiskillScenario(scenario, group, isMultiskillQueue)
        ? MULTISKILL_COLOR
        : (_b = PLAN_COLORS[(_a = scenario === null || scenario === void 0 ? void 0 : scenario.colorIndex) !== null && _a !== void 0 ? _a : -1]) === null || _b === void 0 ? void 0 : _b[1];
}
/**
 * Returns true when the cell is the last in its scenario chunk but NOT the last
 * cell overall — the visual separator between plan groups.
 *
 * Original inline expression: `index + 1 !== arr.length && !((index + 1) % chunkSize)`
 */
export function getHighlightBorder(index, totalLength, chunkSize) {
    return index + 1 !== totalLength && (index + 1) % chunkSize === 0;
}
export function getChunkBaselineValue(values, index, chunkSize) {
    if (chunkSize <= 0)
        return values[0];
    return values[Math.floor(index / chunkSize) * chunkSize];
}
/**
 * Returns the variance payload for expandchildren, or undefined when not
 * applicable (DisplayMode.All hides variance columns).
 *
 * @param displayMode    - Current display mode from useDisplayModeParams.
 * @param baseValue      - The first scenario's value (baseline for comparison).
 * @param currentValue   - This scenario's value.
 * @param isPercentages  - Whether to format the variance as a percentage.
 */
export function getExpandChildren(displayMode, baseValue, currentValue, isPercentages, options) {
    if (displayMode === DisplayMode.All)
        return undefined;
    var base = Number.isFinite(baseValue) ? Number(baseValue) : null;
    var val = Number.isFinite(currentValue) ? Number(currentValue) : null;
    return generateVariances(base, val, isPercentages, options);
}
export var getVarianceDecimalPlaces = function (keyItem, isCurrencyRow) {
    if (keyItem === 'costPerWork') {
        return 2;
    }
    if (isCurrencyRow) {
        return 0;
    }
    return undefined;
};
